module.exports = __webpack_public_path__ + "img/riseup-logo.f8755a77.svg";